import styled from 'styled-components';
import { COLORS, pickThemeFontStyles } from '@/theme';

export const StyledContainerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 2rem 6rem;
  gap: 2rem;
`;

export const StyledContainerTitle = styled.div`
  ${pickThemeFontStyles('20', '30', 'NORMAL')};
  color: ${COLORS.BLACK};
`;

export const StyledHeaderBlock = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
`;

export const StyledContentBlock = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: flex-start;
  gap: 1rem;

  && .ant-table-wrapper {
    width: 100%;
  }
`;

export const StyledAddMoreBlock = styled.div`
  display: flex;
  width: fit-content;
  align-items: center;
  gap: 0.5rem;
`;

export const StyledAddMoreLink = styled.a`
  &&& {
    cursor: pointer;
    text-decoration: none;
  }
`;

export const StyledAddMoreText = styled.div`
  line-height: 1.5rem;
  color: ${COLORS.CHARCOAL};
`;

export const StyledModalTitle = styled.div`
  ${pickThemeFontStyles('16', '24', 'NORMAL')};
  color: ${COLORS.BLACK};
  text-align: center;
  margin-bottom: 1rem;
`;

export const StyledModalButtonsWrapper = styled.div`
  display: flex;
  justify-content: center;
  gap: 1rem;
  margin-top: 1.5rem;
`;
